<template>
  <div class="roles-main">
    <div class="btn-group">
      <span class="download-url">{{ downloadUrl }}</span>
      <el-button
        type="primary"
        size="normal"
        style="box-shadow: 0px 6px 12px 0px #3F8CFF43;"
        @click="copyUrl"
      >
        {{ $t('fields.copy') }}
      </el-button>
      <el-button
        type="primary"
        size="normal"
        style="box-shadow: 0px 6px 12px 0px #3F8CFF43;"
        @click="downloadApk"
      >
        {{ $t('fields.download') }}
      </el-button>
      <el-button
        type="primary"
        size="normal"
        style="box-shadow: 0px 6px 12px 0px #3F8CFF43;"
        @click="qrDialogVisible = true"
      >
        {{ $t('fields.qrCode') }}
      </el-button>
    </div>

    <el-dialog
      :title="$t('fields.qrCode')"
      v-model="qrDialogVisible"
      width="300px"
    >
      <div class="qrcode-container">
        <div ref="qrCodeRef">
          <QrcodeVue :value="downloadUrl" size="200" margin="2" />
        </div>
        <div>{{ $t('referralLink.affiliateScanMe') }}</div>
        <el-button
          type="primary"
          size="normal"
          @click="downloadQrCode"
        >
          {{ $t('fields.download') }}
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue'
import QrcodeVue from 'qrcode.vue'
import { ElMessage } from 'element-plus'
import { useI18n } from 'vue-i18n'
import { getLatestSuccessApk } from '../../../../api/channel-pack'

const emit = defineEmits(['loaded'])

const { t } = useI18n()
const downloadUrl = ref('')
const qrDialogVisible = ref(false)
const qrCodeRef = ref(null)

function copyUrl() {
  navigator.clipboard.writeText(downloadUrl.value)
  ElMessage({ message: t('referralLink.copiedLink'), type: 'success' })
}

function downloadQrCode() {
  const canvas = qrCodeRef.value && qrCodeRef.value.querySelector('canvas')
  if (!canvas) {
    return
  }
  const a = document.createElement('a')
  a.href = canvas.toDataURL('image/png')
  a.download = `${t('fields.appDownload')}.png`
  a.click()
}

function downloadApk() {
  window.open(downloadUrl.value, '_blank')
}

async function loadLatestApk() {
  const { data: apk } = await getLatestSuccessApk()
  downloadUrl.value = apk || ''
  emit('loaded', !!downloadUrl.value)
}

onMounted(() => {
  loadLatestApk()
})
</script>

<style scoped>
.btn-group {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 15px;
}

.download-url {
  word-break: break-all;
  color: #3f8cff;
}

.btn-group .el-button {
  margin-left: 0;
}

.qrcode-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
}
</style>
